const FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

export default function registrationDetails() {
	const toggle = document.querySelector( '.registration__details-toggle' );
	const panel = document.getElementById( 'registration-meta-panel' );

	if ( ! toggle || ! panel ) {
		return;
	}

	function updatePanelTop() {
		const header = document.querySelector( 'header[role="banner"]' );
		if ( header ) {
			const top = header.getBoundingClientRect().bottom;
			panel.style.top = top + 'px';
			panel.style.setProperty( '--registration-panel-top', top + 'px' );
		}
	}

	function openPanel() {
		panel.classList.add( 'is-open' );
		toggle.setAttribute( 'aria-expanded', 'true' );
		updatePanelTop();

		const firstFocusable = panel.querySelector( FOCUSABLE_SELECTOR );
		if ( firstFocusable ) {
			firstFocusable.focus();
		}
	}

	function closePanel() {
		panel.classList.remove( 'is-open' );
		toggle.setAttribute( 'aria-expanded', 'false' );
		toggle.focus();
	}

	toggle.addEventListener( 'click', function() {
		if ( panel.classList.contains( 'is-open' ) ) {
			closePanel();
		} else {
			openPanel();
		}
	} );

	document.addEventListener( 'keydown', function( e ) {
		if ( e.key === 'Escape' && panel.classList.contains( 'is-open' ) ) {
			closePanel();
		}
	} );

	function handleTrapKeydown( e ) {
		if ( e.key !== 'Tab' || ! panel.classList.contains( 'is-open' ) ) {
			return;
		}

		const panelFocusable = Array.from( panel.querySelectorAll( FOCUSABLE_SELECTOR ) );
		const allFocusable = [ toggle, ...panelFocusable ];

		if ( ! allFocusable.length ) {
			return;
		}

		const first = allFocusable[ 0 ];
		const last = allFocusable[ allFocusable.length - 1 ];

		if ( e.shiftKey && document.activeElement === first ) {
			e.preventDefault();
			last.focus();
		} else if ( ! e.shiftKey && document.activeElement === last ) {
			e.preventDefault();
			first.focus();
		}
	}

	document.addEventListener( 'keydown', handleTrapKeydown );

	window.addEventListener( 'resize', function() {
		if ( panel.classList.contains( 'is-open' ) ) {
			updatePanelTop();
		}
	} );
}
